import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'

export default function BasicAreaChart({
  xAxisData = [],
  seriesData = [],
  compStyle = { height: '400px', width: '100%' },
  axisLabelConfig = {
    interval: 0, // แสดง label ทุกรายการ
    rotate: 45, // หมุน label 45 องศา
    fontSize: 10, // ขนาดตัวอักษร
    margin: 10, // ระยะห่างจาก axis
  },
  gridConfig = {
    bottom: 130, // เพิ่มพื้นที่ด้านล่าง
    left: 40,
    right: 40,
    top: 40,
  },
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    tooltip: {
      trigger: 'axis',
      position: function (pt) {
        return [pt[0], '10%']
      },
    },
    xAxis: {
      type: 'category',
      nameLocation: 'middle',
      data: xAxisData,
      axisLabel: axisLabelConfig,
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        data: seriesData,
        type: 'line',
        showSymbol: false,
        areaStyle: {},
      },
    ],
    grid: gridConfig,
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts
        option={chartOption}
        style={compStyle}
        className={'react_for_echarts'}
        onEvents={onEvents}
      />
    </div>
  )
}
